import { DataUtils, Grades, SiteData, TeamData, TeamResults } from "../clients/data-service";
import { OrderByString } from "./DataTools";

export type FilterState = {
    year?: string;
    result?: string;
    person?: string;
};

export function FilterTeams(siteData: SiteData, filter: FilterState) : TeamData[] {
    let filteredTeams = siteData.Teams;
    if (filter.year != null) {
        const yearFilter = filter.year;
        filteredTeams = filteredTeams.filter(t => t.year.toString() === yearFilter);
    }

    if (filter.result != null) {
        const resultFilter = filter.result;
        if (resultFilter === 'Premiers') {
            filteredTeams = filteredTeams.filter(t => t.result === 'Premiers' || t.result === 'Undefeated Premiers');
        } else {
            filteredTeams = filteredTeams.filter(t => t.result === resultFilter);
        }
    }

    if (filter.person != null) {
        const person = siteData.People.find(p=> p.id === filter.person);
        if (person != null) {
            filteredTeams = filteredTeams.filter(t => person.teams.indexOf(t.id) >= 0);
        }
    }

    const grades = Grades().map(g =>  g.Key);
    const sortString = (td: TeamData) : string => {
        return `${td.year}_${grades.indexOf(td.grade)+10}_${td.team_number}`;
    };
    filteredTeams = OrderByString(filteredTeams, td => sortString(td));
    return filteredTeams;

}

export function FilterSummary(filter: FilterState | undefined, siteData: SiteData) : string {
    if (filter == null || NoFilter(filter)) {
        return "All teams";
    }
    let summary = "";
    summary += filter.result ? DataUtils.LookupDisplay(TeamResults(), filter.result) : "All teams";
    
    if (filter.year) {
        summary += " from " + filter.year;
    }

    if (filter.person) {
        const person = siteData.People.find(p => p.id === filter.person)!;
        // summary += " including " +  PersonSurnameFirst(person);
        summary += " including " + person.name;
    }

    return summary;
}

export function NoFilter(filter:  FilterState | undefined) : boolean {
    if (filter == null) {
        return true;
    }
    if (filter.person == null && filter.result == null && filter.year == null) {
        return true;
    }

    return false;
}

export function GetPlayerFilterHighlightString(filter: FilterState, siteData: SiteData) : string|undefined {
    if (filter.person != null) {
        const person = siteData.People.find(p=> p.id === filter.person);
        if (person != null) {
            return person.name;
        }
    }

    return undefined;
}

export function BuildFilter() : FilterState {
    const location = window.location;
    const params = new URLSearchParams(location.search);

    const filterState: FilterState = {};
    filterState.year = params.has('year') ? params.get('year')! : undefined; 
    filterState.result = params.has('result') ? params.get('result')! : undefined; 
    filterState.person = params.has('person') ? params.get('person')! : undefined; 

    return filterState;
}

export function BuildQuery(filterState: FilterState) : string {
    const params = new URLSearchParams();
    if (filterState.year) {
        params.set('year', filterState.year);
    }
    if (filterState.result) {
        params.set('result', filterState.result);
    }
    if (filterState.person) {
        params.set('person', filterState.person);
    }

    return params.toString();
}